var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skycontent", attrs: { id: "aaaa" } }, [
    _c("div", { staticClass: "ssl" }, [
      _c("div", { staticClass: "today" }, [_vm._v(_vm._s(_vm.today))]),
      _vm._v(" "),
      _c("div", { staticClass: "ssk" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search_text,
              expression: "search_text"
            }
          ],
          attrs: { type: "text", placeholder: "请输入搜索内容..." },
          domProps: { value: _vm.search_text },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search_text = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search_select,
                expression: "search_select"
              }
            ],
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.search_select = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "0" } }, [_vm._v("标题")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "1" } }, [_vm._v("内容")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "2" } }, [_vm._v("全部")])
          ]
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "sstp",
          attrs: { src: require("../assets/images/main/ssan.png") },
          on: {
            click: function($event) {
              return _vm.search()
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "skygdcd" },
      [
        _c(
          "slider",
          { ref: "slider", attrs: { options: _vm.options } },
          [
            _vm._l(_vm.someList, function(item, index) {
              return _c("slideritem", { key: index, style: item.style }, [
                _vm._v(" ")
              ])
            }),
            _vm._v(" "),
            _c("div", { attrs: { slot: "loading" }, slot: "loading" }, [
              _vm._v("图片加载中...")
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "skyxw" }, [
      _c(
        "div",
        { staticClass: "xwtpgd" },
        [
          _c(
            "slider",
            { ref: "slider", attrs: { options: _vm.options2 } },
            [
              _vm._l(_vm.xchlist, function(item, index) {
                return _c("slideritem", { key: index, style: item.style })
              }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "loading" }, slot: "loading" }, [
                _vm._v("图片加载中...")
              ])
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "xwgd" }, [
        _c("div", { staticClass: "xwgdtb" }, [
          _c(
            "div",
            {
              staticClass: "xwgdtbout",
              attrs: { id: "bs1" },
              on: {
                mouseover: _vm.overBs1,
                click: function($event) {
                  return _vm.toClsList(25)
                }
              }
            },
            [_vm._v("简讯")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "xwgdtbout",
              attrs: { id: "bs2" },
              on: {
                mouseover: _vm.overBs2,
                click: function($event) {
                  return _vm.toClsList(24)
                }
              }
            },
            [_vm._v("通知")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "xwnr" }, [
          _c("div", { attrs: { id: "tabs1" } }, [
            _c(
              "ul",
              _vm._l(_vm.jxlist, function(article) {
                return _c("li", [
                  _c("img", { attrs: { src: article.isnew } }),
                  _c(
                    "a",
                    {
                      style: { color: article.isTop },
                      on: {
                        click: function($event) {
                          return _vm.toContent(article.id, article.isreprinted)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("filterTitleSub")(article.title, 25))
                      )
                    ]
                  ),
                  _c("span", [_vm._v(_vm._s(article.sendtime))])
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wxgd" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.toClsList(25)
                    }
                  }
                },
                [_vm._v("更多")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "tabs2" } }, [
            _c(
              "ul",
              _vm._l(_vm.tzlist, function(article) {
                return _c("li", [
                  _c("img", { attrs: { src: article.isnew } }),
                  _c(
                    "a",
                    {
                      style: { color: article.isTop },
                      on: {
                        click: function($event) {
                          return _vm.toContent(article.id, article.isreprinted)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("filterTitleSub")(article.title, 25))
                      )
                    ]
                  ),
                  _c("span", [_vm._v(_vm._s(article.sendtime))])
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wxgd" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.toClsList(24)
                    }
                  }
                },
                [_vm._v("更多")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "zjtp" }, [
        _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.toHtml("kypt")
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("../assets/images/main/gd1.png") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.toClsList(160)
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("../assets/images/main/gd2.png") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.toHtml("dqtd")
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("../assets/images/main/gd3.png") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  return _vm.toXch(1, "https://www.gdsky.com.cn/gdslsd")
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("../assets/images/main/gd4.jpg") }
              })
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "skygdcd" },
      [
        _c(
          "slider",
          { ref: "slider", attrs: { options: _vm.options } },
          [
            _vm._l(_vm.add_someList, function(item, index) {
              return _c("slideritem", { key: index, style: item.style }, [
                _vm._v(" ")
              ])
            }),
            _vm._v(" "),
            _c("div", { attrs: { slot: "loading" }, slot: "loading" }, [
              _vm._v("图片加载中...")
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "fczz" }, [
      _c("div", { staticClass: "wmfcm" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.toClsList(170)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../assets/images/main/wmfcm.png") }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wmfctp" }, [
        _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.toClsList(170)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../assets/images/main/cs1.png"),
                  height: "190px",
                  width: "265px"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wmfctpbt" }, [
          _vm._v("行摄绿水青山 助力节水优先")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wmfclb" }, [
        _c(
          "ul",
          _vm._l(_vm.wmfclist, function(article) {
            return _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.toContent(article.id)
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("filterTitleSub")(article.title, 15))
                  )
                ]
              )
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wmfcm" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.toClsList(176)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../assets/images/main/zyzzm.png") }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wmfctp" }, [
        _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.toClsList(176)
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("../assets/images/main/cs2.png") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wmfctpbt" }, [
          _vm._v("水文、水资源调查评价资质证书")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wmfclb" }, [
        _c(
          "ul",
          _vm._l(_vm.zyzzlist, function(article) {
            return _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.toContent(article.id)
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("filterTitleSub")(article.title, 15))
                  )
                ]
              )
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "ztzl" }, [
      _c("div", [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.toClsList(171)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../assets/images/main/zt1.png") }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.toClsList(162)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../assets/images/main/zt2.png") }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.toClsList(178)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../assets/images/main/zt3.png") }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.toClsList(168)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("../assets/images/main/zt4.png") }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(2)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wzdh" }, [
      _c(
        "select",
        {
          attrs: { id: "slbm" },
          on: {
            change: function($event) {
              return _vm.webLink($event)
            }
          }
        },
        [
          _c("option", { attrs: { value: "0" } }, [
            _vm._v("-------------水利部门网站-------------")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.mwr.gov.cn/" } }, [
            _vm._v("水利部")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://slt.gd.gov.cn/" } }, [
            _vm._v("广东水利厅")
          ]),
          _vm._v(" "),
          _c(
            "option",
            { attrs: { value: "http://slt.gd.gov.cn/zsdw_2021/gdsswj/" } },
            [_vm._v("水文局")]
          ),
          _vm._v(" "),
          _c(
            "option",
            { attrs: { value: "http://slt.gd.gov.cn/zsdw_2021/djlyglj/" } },
            [_vm._v("东江流域管理局")]
          ),
          _vm._v(" "),
          _c(
            "option",
            { attrs: { value: "http://slt.gd.gov.cn/zsdw_2021/xjly/" } },
            [_vm._v("西江流域管理局")]
          ),
          _vm._v(" "),
          _c(
            "option",
            { attrs: { value: "http://slt.gd.gov.cn/zsdw_2021/bjlyj/" } },
            [_vm._v("北江流域管理局")]
          ),
          _vm._v(" "),
          _c(
            "option",
            { attrs: { value: "http://slt.gd.gov.cn/zsdw_2021/hjly/" } },
            [_vm._v("韩江流域管理局")]
          ),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.gpdiwe.com/" } }, [
            _vm._v("水利电力规划勘测设计研究院")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          attrs: { id: "gdzf" },
          on: {
            change: function($event) {
              return _vm.webLink($event)
            }
          }
        },
        [
          _c("option", { attrs: { value: "0" } }, [
            _vm._v("-------------广东政府网站-------------")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.gd.gov.cn/" } }, [
            _vm._v("省府办公厅")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://gdstc.gd.gov.cn/" } }, [
            _vm._v("省科技厅")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://gdga.gd.gov.cn/" } }, [
            _vm._v("省公安厅")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://czt.gd.gov.cn/" } }, [
            _vm._v("省财政厅")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://drc.gd.gov.cn/" } }, [
            _vm._v("省发展改革委")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://gdii.gd.gov.cn/" } }, [
            _vm._v("省工业和信息化厅")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://smzt.gd.gov.cn/" } }, [
            _vm._v("省民政厅")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://hrss.gd.gov.cn/" } }, [
            _vm._v("省人力资源社会保障厅")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          attrs: { id: "xwmt" },
          on: {
            change: function($event) {
              return _vm.webLink($event)
            }
          }
        },
        [
          _c("option", { attrs: { value: "0" } }, [
            _vm._v("-------------新闻媒体网站-------------")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.peopledaily.com.cn/" } }, [
            _vm._v("人民日报")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.chinadaily.com.cn/" } }, [
            _vm._v("中国日报")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.gmw.cn/" } }, [
            _vm._v("光明日报")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.peopledaily.com.cn/" } }, [
            _vm._v("人民网")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.xinhuanet.com/" } }, [
            _vm._v("新华网")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.chinanews.com/" } }, [
            _vm._v("中国新闻网")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.chinawater.com.cn/" } }, [
            _vm._v("中国水利网")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "http://www.southcn.com/" } }, [
            _vm._v("南方日报")
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kjfy" }, [
      _c("a", [
        _c("img", {
          attrs: { src: require("../assets/images/main/dsxt3.jpg") }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kjfy" }, [
      _c("a", [
        _c("img", {
          attrs: { src: require("../assets/images/main/dsxt2.jpg") }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("../assets/images/main/zt5.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24282010", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24282010","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainPage.vue
// module id = 296
// module chunks = 34